/**
 * Car type (body style) options for categorizing spots.
 */
export const CAR_TYPES = [
  '',
  'Sedan',
  'Coupe',
  'Convertible',
  'Roadster',
  'Hatchback',
  'Wagon',
  'SUV',
  'Crossover',
  'Truck',
  'Van',
  'Minivan',
  'Other',
] as const;

export type CarType = (typeof CAR_TYPES)[number];

/**
 * Performance type options for categorizing spots.
 */
export const PERFORMANCE_TYPES = [
  '',
  'Sport',
  'Luxury',
  'Grand Tourer',
  'Off-Road',
  'Supercar',
  'Track Car',
  'Muscle Car',
  'Hot Hatch',
  'Hypercar',
  'Other',
] as const;

export type PerformanceType = (typeof PERFORMANCE_TYPES)[number];

/**
 * Engine type options for garage cars.
 */
export const ENGINE_TYPES = [
  '',
  'Inline-3',
  'Inline-4',
  'Inline-5',
  'Inline-6',
  'V4',
  'V6',
  'V8',
  'V10',
  'V12',
  'Flat-4',
  'Flat-6',
  'W12',
  'W16',
  'Rotary',
  'Electric',
  'Hybrid',
  'Other',
] as const;

export type EngineType = (typeof ENGINE_TYPES)[number];

/** Only display car type when it was explicitly chosen from our dropdown (excludes AI values like "Pickup"). */
export const isValidCarType = (v: string | undefined): boolean =>
  !!v && v !== '' && CAR_TYPES.includes(v as CarType);

/** Only display performance type when it was explicitly chosen from our dropdown. */
export const isValidPerformanceType = (v: string | undefined): boolean =>
  !!v && v !== '' && PERFORMANCE_TYPES.includes(v as PerformanceType);
